/*
 ** Tours
 */

let btnShowPricingModal;
let btnScrollTour;
let btnReservation;

function scrollTo(element) {
  console.log(element);
  let bodyRect = document.body.getBoundingClientRect();
  let elemRect = element.getBoundingClientRect();
  let offset = elemRect.top - bodyRect.top;
  window.scroll({
    behavior: "smooth",
    left: 0,
    top: offset - 180,
  });
}

if (document.querySelectorAll("#btnModalReservation").length > 0) {
  btnReservation = document.querySelector("#btnModalReservation").cloneNode(true);
  btnReservation.addEventListener("click", function (e) {
    e.preventDefault();
    let selectorModal = document.querySelector(btnReservation.dataset.target);
    selectorModal.classList.add("show");
    selectorModal.setAttribute("style", "display: block;padding-right: 14px;");
    selectorModal.setAttribute("aria-hidden", "false");
    selectorModal.querySelector(".modal-close").addEventListener("click", function (e) {
      e.preventDefault();
      selectorModal.classList.remove("show");
      selectorModal.removeAttribute("style");
      selectorModal.setAttribute("aria-hidden", "true");
      if (document.querySelectorAll(".modal-backdrop").length > 0) {
        document.querySelector(".modal-backdrop").remove();
        document.querySelector("body").classList.remove("modal-open");
        document.querySelector("body").removeAttribute("style");
      }
    });
  });
}

if (document.querySelectorAll(".js-btn-show-pricing-modal").length > 0) {
  btnShowPricingModal = document.querySelector(".js-btn-show-pricing-modal").cloneNode(true);
  btnShowPricingModal.addEventListener("click", function (e) {
    e.preventDefault();
    let selectorModal = document.querySelector(btnShowPricingModal.dataset.target);
    selectorModal.classList.add("show");
    selectorModal.setAttribute("style", "display: block;padding-right: 14px;");
    selectorModal.setAttribute("aria-hidden", "false");
    selectorModal.querySelector(".modal-close").addEventListener("click", function (e) {
      e.preventDefault();
      selectorModal.classList.remove("show");
      selectorModal.removeAttribute("style");
      selectorModal.setAttribute("aria-hidden", "true");
      if (document.querySelectorAll(".modal-backdrop").length > 0) {
        document.querySelector(".modal-backdrop").remove();
        document.querySelector("body").classList.remove("modal-open");
        document.querySelector("body").removeAttribute("style");
      }
    });
  });
}

if (document.querySelectorAll(".js-btn-scroll-booking-tour").length > 0) {
  btnScrollTour = document.querySelector(".js-btn-scroll-booking-tour").cloneNode(true);
  btnScrollTour.addEventListener("click", function (e) {
    e.preventDefault();
    scrollTo(document.querySelector("#price"));
  });
}

document.addEventListener("DOMContentLoaded", () => {
  // Filters tours

  if (document.querySelectorAll(".wrapper-filters-tours").length > 0) {
    // All Tour boxes
    let tours = document.querySelectorAll(".tour-box-filter");
    let toursold = document.querySelectorAll(".tour-box-old");

    // click on filter
    let filtersTour = document.querySelectorAll(".chk-filter-tour");
    let theme = null;

    for (const filter of filtersTour) {
      filter.addEventListener("click", function (e) {
        theme = filter.value;

        for (const filterToCheck of filtersTour) {
          if (filterToCheck !== filter) {
            filterToCheck.checked = false;
          }
        }

        for (const tour of tours) {
          let themeTour = tour.dataset.theme;
          tour.classList.remove("hidden");

          !themeTour.includes(theme) && filter.checked === true;

          if (!themeTour.includes(theme) && filter.checked === true) {
            tour.classList.add("hidden");
          }
        }

        if (toursold.length > 0) {
          for (const tour of toursold) {
            let themeTour = tour.dataset.theme;
            tour.classList.remove("hidden");

            !themeTour.includes(theme) && filter.checked === true;

            if (!themeTour.includes(theme) && filter.checked === true) {
              tour.classList.add("hidden");
            }
          }
        }
      });
    }

    if (document.querySelectorAll(".js-remove-filter-tour").length > 0) {
      let buttonRemoveFilter = document.querySelector(".js-remove-filter-tour");

      buttonRemoveFilter.addEventListener("click", function (e) {
        e.preventDefault();
        for (const filterToCheck of filtersTour) {
          filterToCheck.checked = false;
        }
        for (const tour of tours) {
          tour.classList.remove("hidden");
        }
      });
    }
  }

  if (document.querySelectorAll(".wrapper-filter-date-tour").length > 0) {
    let allFilterDateTours = document.querySelectorAll(".js-date-filter-tour");
    let tours = document.querySelectorAll(".tour-box-filter");
    let dateDaySelected = null;
    let buttonRemoveFilterDateTour = document.querySelector(".js-reset-filter-date-tour");

    for (const filterDateTour of allFilterDateTours) {
      filterDateTour.addEventListener("click", function (e) {
        e.preventDefault();
        buttonRemoveFilterDateTour.classList.remove("hidden");
        for (const filterDateTour of allFilterDateTours) {
          filterDateTour.classList.remove("active");
        }
        filterDateTour.classList.add("active");

        dateSelectFormatted = new Date(filterDateTour.dataset.dateday * 1000);
        formattedDate = ("0" + dateSelectFormatted.getDate()).slice(-2) + "." + ("0" + (dateSelectFormatted.getMonth() + 1)).slice(-2) + "." + dateSelectFormatted.getFullYear();
        dateDaySelected = filterDateTour.dataset.dateday;

        for (const tour of tours) {
          let dateTourStart = tour.dataset.datestart ? tour.dataset.datestart : null;
          let dateTourEnd = tour.dataset.dateend ? tour.dataset.dateend : null;
          let datealltour = tour.dataset.datealltour ? tour.dataset.datealltour : null;
          tour.classList.remove("hidden");

          if (!(datealltour && datealltour.includes("," + formattedDate))) {
            tour.classList.add("hidden");
            if (tour.querySelector(".js-date-tour") && tour.querySelector(".js-date-tour").dataset.datenext) {
              tour.querySelector(".js-date-tour").innerHTML = tour.querySelector(".js-date-tour").dataset.datenext;
            }
          } else {
            if (tour.querySelector(".js-date-tour") && tour.querySelector(".js-date-tour").dataset.datenext) {
              tour.querySelector(".js-date-tour").innerHTML = formattedDate;
            }
          }

          if (dateTourStart && dateTourEnd && parseInt(dateDaySelected) >= parseInt(dateTourStart) && parseInt(dateDaySelected) <= parseInt(dateTourEnd)) {
            tour.classList.remove("hidden");
          }
        }
        // scrollTo(document.getElementById("wrapperEntitesTours"));
      });
    }

    buttonRemoveFilterDateTour.addEventListener("click", function (e) {
      e.preventDefault();
      buttonRemoveFilterDateTour.classList.add("hidden");
      for (const filterDateTour of allFilterDateTours) {
        filterDateTour.classList.remove("active");
      }

      for (const tour of tours) {
        tour.classList.remove("hidden");
        if (tour.querySelector(".js-date-tour") && tour.querySelector(".js-date-tour").dataset.datenext) {
          tour.querySelector(".js-date-tour").innerHTML = tour.querySelector(".js-date-tour").dataset.datenext;
        }
      }

      // scrollTo(document.getElementById("wrapperEntitesTours"));
    });

    let openFlatpickerTour = document.querySelector(".js-open-datepicker-tour");
    let modalTourDatepicker = document.querySelector(".modal-tour-datepicker");
    let closeModalTourDatepicker = document.querySelector(".js-close-modal-tour-datepicker");
    let flatpickerInlineTour = flatpickr(".js-datepicker-inline-tour", {
      minDate: "today",
      inline: true,
      monthSelectorType: "static",
      locale: document.querySelector("body").dataset.lang,
      onChange: function (selectedDate) {
        dateSelectFormatted = new Date(selectedDate);
        formattedDate = ("0" + dateSelectFormatted.getDate()).slice(-2) + "." + ("0" + (dateSelectFormatted.getMonth() + 1)).slice(-2) + "." + dateSelectFormatted.getFullYear();
        dateDaySelected = Math.floor((new Date(selectedDate).getTime() + 6 * 3600000) / 1000);
        buttonRemoveFilterDateTour.classList.remove("hidden");
        for (const tour of tours) {
          let dateTourStart = tour.dataset.datestart ? tour.dataset.datestart : null;
          let dateTourEnd = tour.dataset.dateend ? tour.dataset.dateend : null;
          let datealltour = tour.dataset.datealltour ? tour.dataset.datealltour : null;
          tour.classList.remove("hidden");

          if (!(datealltour && datealltour.includes("," + formattedDate))) {
            tour.classList.add("hidden");
            if (tour.querySelector(".js-date-tour") && tour.querySelector(".js-date-tour").dataset.datenext) {
              tour.querySelector(".js-date-tour").innerHTML = tour.querySelector(".js-date-tour").dataset.datenext;
            }
          } else {
            if (tour.querySelector(".js-date-tour") && tour.querySelector(".js-date-tour").dataset.datenext) {
              tour.querySelector(".js-date-tour").innerHTML = formattedDate;
            }
          }

          if (dateTourStart && dateTourEnd && parseInt(dateDaySelected) >= parseInt(dateTourStart) && parseInt(dateDaySelected) <= parseInt(dateTourEnd)) {
            tour.classList.remove("hidden");
          }
        }
        modalTourDatepicker.classList.add("hidden");
        // scrollTo(document.getElementById("wrapperEntitesTours"));
      },
    });

    openFlatpickerTour.addEventListener("click", function (e) {
      modalTourDatepicker.classList.remove("hidden");
    });

    closeModalTourDatepicker.addEventListener("click", function (e) {
      modalTourDatepicker.classList.add("hidden");
    });

    if (document.querySelectorAll(".js-tab-reset-filters-tours")) {
      let resetFiltersTab = document.querySelectorAll(".js-tab-reset-filters-tours");
      let filtersTour = document.querySelectorAll(".chk-filter-tour");
      for (const resetFilterTab of resetFiltersTab) {
        resetFilterTab.addEventListener("click", function (e) {
          buttonRemoveFilterDateTour.classList.add("hidden");
          for (const filterToCheck of filtersTour) {
            filterToCheck.checked = false;
          }
          for (const filterDateTour of allFilterDateTours) {
            filterDateTour.classList.remove("active");
          }
          for (const tour of tours) {
            tour.classList.remove("hidden");
            if (tour.querySelector(".js-date-tour") && tour.querySelector(".js-date-tour").dataset.datenext) {
              tour.querySelector(".js-date-tour").innerHTML = tour.querySelector(".js-date-tour").dataset.datenext;
            }
          }
        });
      }
    }
  }

  if (document.querySelectorAll(".datepicker").length > 0) {
    let datesToDisable = [];
    if (document.querySelector(".datepicker").dataset.excludeddates && document.querySelector(".datepicker").dataset.excludeddates.split(",").length > 1) {
      datesToDisable = document.querySelector(".datepicker").dataset.excludeddates.split(",");
    } else if (document.querySelector(".datepicker").dataset.excludeddates && document.querySelector(".datepicker").dataset.excludeddates.split(",").length == 1) {
      datesToDisable.push(document.querySelector(".datepicker").dataset.excludeddates);
    }
    if (document.querySelector(".datepicker").dataset.useholidays) {
      fetch("/js/holidays.json")
        .then((response) => response.json())
        .then((data) => {
          for (const item of data) {
            const formattedDate = item.date;
            const currentDate = new Date();
            const formattedDateObject = new Date(formattedDate);
            if (formattedDateObject.getTime() >= currentDate.getTime()) {
              datesToDisable.push(item.date);
            }
          }

          flatpickr(".datepicker-tour", {
            minDate: new Date().fp_incr(10),
            allowInput: true,
            locale: document.querySelector("body").dataset.lang,
            disable: datesToDisable,
          });
        })
        .catch((error) => console.error(error));
    } else {
      flatpickr(".datepicker-tour", {
        minDate: new Date().fp_incr(10),
        allowInput: true,
        locale: document.querySelector("body").dataset.lang,
        disable: datesToDisable,
      });
    }

    flatpickr(".hourpicker-tour", {
      enableTime: true,
      allowInput: true,
      noCalendar: true,
      dateFormat: "H:i",
      time_24hr: true,
      locale: document.querySelector("body").dataset.lang,
      onOpen: function (selectedDates, dateStr, instance) {
        if (dateStr === "") {
          instance.setDate("12:00");
        }
      },
    });
    // document.addEventListener('click',function(e) {
    //     if (e.target && e.target.classList.contains('datepicker-tour')) {
    //         console.log(e);
    //         flatpickr(".datepicker-tour",{
    //             minDate: 'today',
    //             allowInput: true,
    //             "locale": document.querySelector('body').dataset.lang,
    //         })
    //     }
    //
    //     if (e.target && e.target.classList.contains('hourpicker-tour')) {
    //         flatpickr(".hourpicker-tour",{
    //             enableTime: true,
    //             allowInput: true,
    //             noCalendar: true,
    //             dateFormat: "H:i",
    //             time_24hr: true,
    //             "locale": document.querySelector('body').dataset.lang,
    //         })
    //     }
    // });
  }

  if (document.querySelectorAll("#nbguide").length > 0) {
    let inputPrice = document.querySelector("#nbguide");
    inputPrice.addEventListener("change", function (e) {
      document.querySelector("#total").value = inputPrice.value * inputPrice.dataset.pricegroup;
    });
  }

  if (document.querySelectorAll("#formTour").length > 0) {
    document.querySelector("#formTour button").addEventListener("click", function (e) {
      if (grecaptcha && grecaptcha.getResponse().length > 0 && document.querySelector("#formTour").checkValidity() === true) {
        document.querySelector("#formTour").submit();
      } else {
        document.querySelector("#errorRecaptcha").classList.remove("hidden");
        let forms = document.getElementsByClassName("needs-validation");
        let validation = Array.prototype.filter.call(forms, function (form) {
          form.addEventListener(
            "submit",
            function (event) {
              if (form.checkValidity() === true) {
                event.preventDefault();
                event.stopPropagation();
              }
            },
            false,
          );
        });
      }
    });
  }

  if (document.querySelectorAll(".js-select-type-status").length > 0) {
    const selectStatus = document.querySelector(".js-select-type-status");
    selectStatus.addEventListener("change", (e) => {
      e.preventDefault();
      if (selectStatus.value === "individual") {
        document.querySelectorAll(".js-individual-info").forEach((element) => {
          element.classList.remove("hidden");
        });
        document.querySelectorAll(".js-company-info").forEach((element) => {
          element.classList.add("hidden");
        });
      } else {
        document.querySelectorAll(".js-individual-info").forEach((element) => {
          element.classList.remove("hidden");
        });
        document.querySelectorAll(".js-company-info").forEach((element) => {
          element.classList.remove("hidden");
        });
      }
    });
  }

  if (document.querySelectorAll(".js-select-tour") && document.querySelectorAll(".js-select-tour").length > 0) {
    const selectTour = document.querySelector(".js-select-tour");
    selectTour.addEventListener("change", (e) => {
      e.preventDefault();
      if (selectTour.value === "Visite guidée du Stade de Luxembourg" || selectTour.value === "Guided tour of Stade de Luxembourg" || selectTour.value === "Rundgang durch das Stade de Luxembourg") {
        document.querySelector(".js-date-tour-select").classList.add("hidden");
        document.querySelector(".js-date-tour-select").removeAttribute("required");
        document.querySelector(".js-time-tour-select").classList.add("hidden");
        document.querySelector(".js-time-tour-select").removeAttribute("required");
      } else {
        document.querySelector(".js-date-tour-select").classList.remove("hidden");
        document.querySelector(".js-date-tour-select").setAttribute("required", "true");
        document.querySelector(".js-time-tour-select").classList.remove("hidden");
        document.querySelector(".js-time-tour-select").setAttribute("required", "true");
      }
    });
  }

  if (document.querySelectorAll(".js-info-address").length > 0 && document.querySelectorAll(".js-billing-address").length > 0) {
    const infoTitle = document.querySelector(".js-info-title");
    const billingTitle = document.querySelector(".js-billing-title");
    const infoName = document.querySelector(".js-info-name");
    const billingName = document.querySelector(".js-billing-name");
    const infoFirstname = document.querySelector(".js-info-firstname");
    const billingFirstname = document.querySelector(".js-billing-firstname");
    const infoAddress = document.querySelector(".js-info-address");
    const billingAddress = document.querySelector(".js-billing-address");
    const infoZipcode = document.querySelector(".js-info-zipcode");
    const billingZipcode = document.querySelector(".js-billing-zipcode");
    const infoCity = document.querySelector(".js-info-city");
    const billingCity = document.querySelector(".js-billing-city");
    const infoCountry = document.querySelector(".js-info-country");
    const billingCountry = document.querySelector(".js-billing-country");
    const infoEmail = document.querySelector(".js-info-email");
    const billingEmail = document.querySelector(".js-billing-email");
    const infoPhone = document.querySelector(".js-info-phone");
    const billingPhone = document.querySelector(".js-billing-phone");
    const checkSameAsContact = document.querySelector(".js-issameascontact");
    infoTitle.addEventListener("change", (e) => {
      e.preventDefault();
      if (document.querySelector(".js-issameascontact").checked) {
        billingTitle.value = infoTitle.value;
      }
    });
    infoName.addEventListener("keyup", (e) => {
      e.preventDefault();
      if (document.querySelector(".js-issameascontact").checked) {
        billingName.value = infoName.value;
      }
    });
    infoFirstname.addEventListener("keyup", (e) => {
      e.preventDefault();
      if (document.querySelector(".js-issameascontact").checked) {
        billingFirstname.value = infoFirstname.value;
      }
    });
    infoAddress.addEventListener("keyup", (e) => {
      e.preventDefault();
      if (document.querySelector(".js-issameascontact").checked) {
        billingAddress.value = infoAddress.value;
      }
    });
    infoZipcode.addEventListener("keyup", (e) => {
      e.preventDefault();
      if (document.querySelector(".js-issameascontact").checked) {
        billingZipcode.value = infoZipcode.value;
      }
    });
    infoCity.addEventListener("keyup", (e) => {
      e.preventDefault();
      if (document.querySelector(".js-issameascontact").checked) {
        billingCity.value = infoCity.value;
      }
    });
    infoCountry.addEventListener("keyup", (e) => {
      e.preventDefault();
      if (document.querySelector(".js-issameascontact").checked) {
        billingCountry.value = infoCountry.value;
      }
    });
    infoEmail.addEventListener("keyup", (e) => {
      e.preventDefault();
      if (document.querySelector(".js-issameascontact").checked) {
        billingEmail.value = infoEmail.value;
      }
    });
    infoPhone.addEventListener("keyup", (e) => {
      e.preventDefault();
      if (document.querySelector(".js-issameascontact").checked) {
        billingPhone.value = infoPhone.value;
      }
    });

    checkSameAsContact.addEventListener("change", (e) => {
      e.preventDefault();
      if (checkSameAsContact.checked) {
        billingTitle.setAttribute("readonly", "readonly");
        billingTitle.value = infoTitle.value;
        billingName.setAttribute("readonly", "readonly");
        billingName.value = infoName.value;
        billingFirstname.setAttribute("readonly", "readonly");
        billingFirstname.value = infoFirstname.value;
        billingAddress.setAttribute("readonly", "readonly");
        billingAddress.value = infoAddress.value;
        billingZipcode.setAttribute("readonly", "readonly");
        billingZipcode.value = infoZipcode.value;
        billingCity.setAttribute("readonly", "readonly");
        billingCity.value = infoCity.value;
        billingCountry.setAttribute("readonly", "readonly");
        billingCountry.value = infoCountry.value;
        billingEmail.setAttribute("readonly", "readonly");
        billingEmail.value = infoEmail.value;
        billingPhone.setAttribute("readonly", "readonly");
        billingPhone.value = infoPhone.value;
      } else {
        billingTitle.removeAttribute("readonly");
        billingTitle.value = "";
        billingName.removeAttribute("readonly");
        billingName.value = "";
        billingFirstname.removeAttribute("readonly");
        billingFirstname.value = "";
        billingAddress.removeAttribute("readonly");
        billingAddress.value = "";
        billingZipcode.removeAttribute("readonly");
        billingZipcode.value = "";
        billingCity.removeAttribute("readonly");
        billingCity.value = "";
        billingCountry.removeAttribute("readonly");
        billingCountry.value = "";
        billingEmail.removeAttribute("readonly");
        billingEmail.value = "";
        billingPhone.removeAttribute("readonly");
        billingPhone.value = "";
      }
    });
  }
});
